import { useEffect, useState } from "react";
import { isMeetingPast, isMeetingJoinable, getMeetingGraceLabels } from "../Helpers/meetingHelper";
import { MEETING_STATUS_CHECK_INTERVAL_MS } from "../Constants/constantValues";

export const useMeetingJoinGrace = (meeting) => {
  const [, forceTick] = useState(0);

  useEffect(() => {
    if (isMeetingPast(meeting) && !isMeetingJoinable(meeting)) {
      return;
    }

    const interval = setInterval(() => {
      forceTick((tick) => tick + 1);
    }, MEETING_STATUS_CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [meeting?.id]);

  const isPast = isMeetingPast(meeting);
  const isJoinable = isMeetingJoinable(meeting);
  const inGracePeriod = isPast && isJoinable;
  const { endedLabel, expiresLabel } = isPast
    ? getMeetingGraceLabels(meeting)
    : { endedLabel: "", expiresLabel: "" };

  return { isPast, isJoinable, inGracePeriod, endedLabel, expiresLabel };
};
